var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_17)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_17",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.57676 4.79492L23.3182 12.4485H8.86801L23.9201 22.2608H4.57676V4.79492ZM3.43854 3.46045V23H26.661L11.6089 13.1877H27.2628L3.43854 3.46045Z",
    fill: "#273B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00769 4.12769V22.6271H25.2873L10.2418 12.8148H25.2873L4.00769 4.12769Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3259 12.3177C11.6678 12.3177 13.5648 11.0813 13.5648 9.55716C13.1919 10.1721 12.5182 10.6823 11.6612 11.0159L11.2949 10.8393L12.0079 10.4926L11.1444 10.3487L11.6023 9.85153L10.7192 9.93657L10.8435 9.36091L10.0782 9.65528L9.85576 9.09271L9.31936 9.55716L8.78295 9.09271L8.56054 9.65528L7.79518 9.36091L7.92601 9.93657L7.0429 9.85153L7.50081 10.3487L6.63733 10.4926L7.35035 10.8393L6.98403 11.0159C6.12709 10.6823 5.45331 10.1655 5.08044 9.55716C5.08699 11.0813 6.98403 12.3177 9.3259 12.3177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1191 18.2116L13.8788 17.721L12.1191 17.2304L13.2705 16.2361L11.3669 16.3865L11.6024 15.1502L10.0716 15.9024L9.32591 14.7511L8.58018 15.9024L7.04946 15.1502L7.28496 16.3865L5.38137 16.2361L6.53922 17.2304L4.77301 17.721L6.53922 18.2116L5.38137 19.2059L7.28496 19.0555L7.04946 20.2918L8.58018 19.5395L9.32591 20.6908L10.0716 19.5395L11.6024 20.2918L11.3669 19.0555L13.2705 19.2059L12.1191 18.2116Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_17",
    x: 0.438538,
    y: 0.460449,
    width: 29.8243,
    height: 25.5396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_17"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_17",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepal);
export default __webpack_public_path__ + "static/media/Nepal.529ff9a21ad4a2e190e62c6a1812fad3.svg";
export { ForwardRef as ReactComponent };